import PropertyEditContainer from './containers/PropertyEditContainer'

export default PropertyEditContainer
